var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { PureComponent } from "react";
import client, { pagination, emptyList } from "@irati/utils/services/apollo";
import RefetchOnMount from "@irati/utils/services/apollo/utils/RefetchOnMount";
import Query from "@irati/utils/services/apollo/Query";
import usersQuery, { usersForBusinessKey } from "../../services/queries/usersForBusiness";
export var query = usersQuery;
export function handleActivationStatusChange(variables, user) {
    if ((variables.enabled === true && !user.isEnabled) ||
        (variables.enabled === false && user.isEnabled)) {
        removeFromUserList(variables, user);
    }
}
export function removeFromUserList(variables, user) {
    var _a;
    try {
        var data = client.readQuery({ query: query, variables: variables });
        var users = userList({ data: data });
        var updatedList = users.results.filter(function (t) { return t.uuid !== user.uuid; });
        client.writeQuery({ query: query, variables: variables, data: (_a = {}, _a[usersForBusinessKey] = __assign(__assign({}, users), { results: updatedList }), _a) });
    }
    catch (e) {
        console.error("[DealList]: Failed to update cache");
    }
}
export function userList(apollo) {
    var _a;
    return ((_a = apollo.data) === null || _a === void 0 ? void 0 : _a[usersForBusinessKey]) || emptyList();
}
export function getPage(apollo, variables, pageIndex) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, offset;
        return __generator(this, function (_b) {
            _a = userList(apollo).offset, offset = _a === void 0 ? 0 : _a;
            if (offset === 0 || offset / variables.limit === pageIndex) { // have page?
                return [2 /*return*/, getNextPage(apollo, variables)];
            }
            return [2 /*return*/];
        });
    });
}
export function getNextPage(apollo, variables) {
    var _a = userList(apollo), results = _a.results, total = _a.total;
    if (results.length < total) { // expect more?
        return apollo.nextPage(__assign({ includeBusiness: variables.includeBusiness || false }, variables));
    }
}
var LoadUsersQuery = /** @class */ (function (_super) {
    __extends(LoadUsersQuery, _super);
    function LoadUsersQuery() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.refetch = new RefetchOnMount(_this);
        _this.componentDidMount = function () {
            // Disable until we remove the refetches in parent components (this will happen when user profile popup dies)
            // this.refetch.didMount()
        };
        return _this;
    }
    LoadUsersQuery.getDerivedStateFromProps = function (props, state) {
        return RefetchOnMount.onUpdate(props, state);
    };
    LoadUsersQuery.prototype.render = function () {
        var _a = this.props, children = _a.children, props = __rest(_a, ["children"]);
        var variables = __assign({ includeBusiness: this.props.variables.includeBusiness || false }, this.props.variables);
        return (React.createElement(Query, __assign({}, props, { variables: variables, query: query }), function (apollo) {
            var nextPage = function (nextPageVariables) { return pagination({ query: query, variables: nextPageVariables }, apollo); };
            return children(__assign(__assign({}, apollo), { nextPage: nextPage }));
        }));
    };
    return LoadUsersQuery;
}(PureComponent));
export default LoadUsersQuery;
